<template>
  <v-container>
    <bread-crumbs :items="breadCrumbs"/>

    <v-dialog v-model="dialogNew" max-width="330">
      <v-card class="pa-2">
        <v-icon small class="size" color="main" @click="dialogNew = false">mdi-close</v-icon>
        <v-card-text class="text-center">
          <custom-text-field label="نام اپلیکیشن" v-model="appName" class="mt-1"/>
          <custom-text-field label="آی دی اپلیکیشن" v-model="appId" class="mt-1"/>
        </v-card-text>

        <v-card-actions class="">
          <v-btn class="primary w-100 mb-3" dark @click="confirmNew">ایجاد</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="330">
      <v-card class="pa-2">
        <v-icon small class="size" color="main" @click="dialog = false">mdi-close</v-icon>
        <v-card-text class="text-center">
          <v-img src="/img/warning.png" width="120" class="mx-auto mb-2"/>
          <span class="textMainColor">آیا از تغییر نقش به ادمین مطمئن هستید؟</span>
        </v-card-text>

        <v-card-actions class="">
          <v-btn class="primary w-100 mb-3" dark @click="confirm">تائید</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
<!--<v-card class="pa-5">-->
<!--  <v-row class="mt-6">-->
<!--    <v-col cols="12" sm="4" md="4" lg="4">-->
<!--      <label>تاريخ شروع(شمسی)</label>-->
<!--      <date-picker auto-submit v-model="startDate"></date-picker>-->
<!--    </v-col>-->

<!--    <v-col cols="12" sm="4" md="4" lg="4">-->
<!--      <label>تاريخ خاتمه(شمسی)</label>-->
<!--      <date-picker-->
<!--        auto-submit-->
<!--        :min="startDate"-->
<!--        v-model="endDate"-->
<!--        :disabled="endDateDisable"-->
<!--      ></date-picker>-->
<!--    </v-col>-->
<!--    <v-col cols="12" sm="4" md="4" lg="4">-->
<!--      <label>تاریخ صورتحساب</label>-->
<!--      <date-picker auto-submit v-model="search_bill_date" ></date-picker>-->
<!--    </v-col>-->
<!--  </v-row>-->
<!--  <v-row class="mt-6">-->
<!--    <v-col cols="12" sm="4" md="3" lg="3"><custom-text-field label="شماره صورتحساب" v-model="search_bill_number" class="mt-1"/></v-col>-->
<!--    <v-col cols="12" sm="4" md="3" lg="3"><custom-text-field label=" کد مشتری" v-model="search_customer_code" class="mt-1"/></v-col>-->
<!--    <v-col cols="12" sm="4" md="3" lg="3"><custom-text-field label=" بهره بردار" v-model="search_customer_name" class="mt-1"/></v-col>-->

<!--    <v-col cols="12" sm="2" lg="2" class="d-flex">-->
<!--      <v-btn-->
<!--        small-->
<!--        align="center"-->
<!--        justify="center"-->
<!--        class="indigo mt-1 pa-4"-->
<!--        @click="filter"-->
<!--      >-->
<!--        فیلتر-->
<!--      </v-btn>-->
<!--      <v-btn-->
<!--        small-->
<!--        align="center"-->
<!--        justify="center"-->
<!--        class="warning mx-auto mt-1 mr-2 pa-4"-->
<!--        @click="resetForm"-->
<!--      >-->
<!--        <v-icon color="">mdi-refresh-circle</v-icon>-->
<!--      </v-btn>-->
<!--    </v-col>-->
<!--  </v-row>-->
<!--</v-card>-->


    <v-card class="pt-8 mt-3">
      <h4 class="container-title">لیست فاکتورها </h4>

      <v-card-text class="pa-5">
        <v-sheet elevation="4" v-if="factorsListData" class="mt-5">


          <export-excel
            class="btn btn-default"
            :data="factorsListData"
            :fields="json_fields"
            :title="excelTitle"
            :worksheet="fileName"
            :name="`${fileName}.xls`">

            <v-btn color="indigo darken-1"> خروجی اکسل</v-btn>

          </export-excel>

          <v-data-table
            id="exportTable"
            :headers="headers"
            :items="factorsListData"
            :items-per-page="10"
            class="elevation-3"
            :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-plus',
        nextIcon: 'mdi-minus',
        itemsPerPageOptions:[10,15]
      }"
          >

            <template v-slot:[`item.fee`]="{ item }">{{ thousandComma(item.fee) }}</template>
            <template v-slot:[`item.sell_price`]="{ item }">{{ thousandComma(item.sell_price) }}</template>
            <template v-slot:[`item.discount`]="{ item }">{{ thousandComma(item.discount) }}</template>
            <template v-slot:[`item.tax`]="{ item }">{{ thousandComma(item.tax) }}</template>
            <template v-slot:[`item.toll`]="{ item }">{{ thousandComma(item.toll) }}</template>
            <template v-slot:[`item.pure`]="{ item }">{{ thousandComma(item.pure) }}</template>
            <template v-slot:[`item.sell_after_discount`]="{ item }">{{ thousandComma(item.sell_after_discount) }}</template>
            <template v-slot:[`item.bill_date`]="{ item }">{{ transformDateToJalali(item.bill_date) }}</template>
            <template v-slot:[`item.start_date`]="{ item }">{{ transformDateToJalali(item.start_date) }}</template>
            <template v-slot:[`item.end_date`]="{ item }">{{ transformDateToJalali(item.end_date) }}</template>
          </v-data-table>
        </v-sheet>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<!--// {-->
<!--//   "customer_code": q.customer_code,-->
<!--//   "customer_name": q.customer_name,-->
<!--//   "unit": q.unit,-->
<!--//   "rack": q.rack,-->
<!--//   "server": q.server,-->
<!--//   "contract_number": q.contract_number,-->
<!--//   "el1": q.el1,-->
<!--//   "el2": q.el2,-->
<!--//   "el3": q.el3,-->
<!--//   "contract_start_date": q.contract_start_date,-->
<!--//   "contract_end_date": q.contract_end_date,-->
<!--//   "contract_cost": return_num(q.contract_cost),-->
<!--//   "bill_number": q.bill_number,-->
<!--//   "bill_date": return_jalali_date(q.bill_date),-->
<!--//   "sell": return_num(q.sell),-->
<!--//   "discount": return_num(q.discount),-->
<!--//   "net_sell": return_num(q.net_sell),-->
<!--//   "tax": return_num(q.tax),-->
<!--//   "sell_and_tax": return_num(q.sell_and_tax),-->
<!--//   "start_date": return_date(q.start_date, false),-->
<!--//   "end_date": return_date(q.end_date, true)-->
<!--// }-->
<script>
import CustomTextField from "@/components/base/CustomTextField";
import {thousandComma} from "@/plugins/helper";
export default {
  name: "contractList",
  components: {CustomTextField},
  data() {
    return {
      thousandComma,
      page: 1,
      totalUsers: 0,
      numberOfPages: 0,
      loading: true,
      options: {},
      confirmID: null,
      dialog: false,
      dialogConsult: false,
      dialogAdmin: false,
      totalDesserts: 0,
      desserts: [],
      breadCrumbs: [
        {
          text: "داشبورد",
          disabled: false,
          to: {name: "Dashboard"},
          exact: true,
        },
        {
          text: "لیست قرارداد ها",
          disabled: false,
          to: {name: "ContractList"},
          exact: true,
        },
        {
          text: "لیست فاکتورها",
          disabled: true,
          exact: true,
        },
      ],
    // {

    //   "customer_code": q.customer_code,
    //   "cutomer": q.cutomer,
    //   "customer_name":q.customer_name,
    //   "sell_type": q.sell_type,
    //   "kala_code": q.kala_code,
    //   "kala": q.kala,
    //   "vahed": q.vahed,
    //   "prime-num": return_num(q.num),
    //   "fee": return_num(q.fee),
    //   "sell_price": return_num(q.sell_price),
    //   "discount": return_num(q.discount),
    //   "sell_after_discount": return_num(q.sell_after_discount),
    //   "tax": return_num(q.tax),
    //   "toll":return_num(q.toll),
    //   "pure": return_num(q.pure),
    //   "month":q.month,
    //   "currency": q.currency
    // }
      headers: [

        {text: "نوع سند", value: "sanad_type", sortable: true},
        {text: "شماره", value: "number", sortable: true},
        {text: "تاريخ", value: "date", sortable: true},
        {text: "كد مشتري", value: "customer_code", sortable: true},
        {text: "مشتري", value: "cutomer", sortable: true, width: '230px'},
        {text: "نام مشتري", value: "customer_name", sortable: true, width: '230px'},
        {text: "نوع فروش", value: "sell_type", sortable: true},
        {text: "كد كالا/خدمت", value: "kala_code", sortable: true},
        {text: "كالا/خدمت", value: "kala", sortable: true},
        {text: "واحد اصلي", value: "vahed", sortable: true},
        {text: "مقدار-اصلي", value: "prime-num", sortable: true},
        {text: "في", value: "fee", sortable: true},
        {text: "مبلغ فروش", value: "sell_price", sortable: true},
        {text: "تخفيف", value: "discount", sortable: true},
        {text: "مبلغ بعد از تخفیف", value: "sell_after_discount", sortable: true},
        {text: "ماليات ", value: "tax", sortable: true},
        {text: "عوارض", value: "toll", sortable: true},
        {text: "خالص", value: "pure", sortable: true},
        {text: "ماه", value: "month", sortable: true},
        {text: "ارز", value: "currency", sortable: true},


      ],
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        numberRule: (v) => {
          if (!v.trim()) return true;
          if (!isNaN(parseFloat(v)) && v >= 0) return true;
          return "لطفا عدد وارد نمائید";
        },
      },
      searchName: '',
      searchMobile: '',
      confirmMethod: null,
      confirmRole: '',
      introductionLetterUrl: '',
      lawDocumentUrl: '',
      confirmStateId: '',
      dialogState: false,
      dialogUserProfile: false,
      dialogNew: false,
      appName: '',
      appId: '',
      search_customer_name: '',
      search_customer_code: '',
      search_bill_number: '',
      search_bill_date: '',

    // {text: "نوع سند", value: "sanad_type", sortable: false},
    // {text: "شماره", value: "number", sortable: false, width: '230px'},
    // {text: "تاريخ", value: "date", sortable: false},
    // {text: "كد مشتري", value: "customer_code", sortable: false},
    // {text: "مشتري", value: "cutomer", sortable: false},
    // {text: "نام مشتري", value: "customer_name", sortable: false},
    // {text: "نوع فروش", value: "sell_type", sortable: false},
    // {text: "كد كالا/خدمت", value: "kala_code", sortable: false},
    // {text: "كالا/خدمت", value: "kala  ", sortable: false},
    // {text: "واحد اصلي", value: "vahed", sortable: false},
    // {text: "مقدار-اصلي", value: "prime-num", sortable: false},
    // {text: "في", value: "fee", sortable: false},
    // {text: "مبلغ فروش", value: "sell_price", sortable: false},
    // {text: "تخفيف", value: "discount", sortable: false},
    // {text: "مبلغ بعد از تخفیف", value: "sell_after_discount", sortable: false},
    // {text: "ماليات ", value: "tax", sortable: false},
    // {text: "عوارض", value: "toll", sortable: false},
    // {text: "خالص", value: "pure", sortable: false},
    // {text: "ماه", value: "month", sortable: false},
    // {text: "ارز", value: "currency", sortable: false},

      json_fields: {
        "نوع سند": 'sanad_type',
        "شماره": 'number',
        "تاريخ": 'date',
        "كد مشتري": 'customer_code',
        "مشتري": 'cutomer',
        "نام مشتري": 'customer_name',
        "نوع فروش": 'sell_type',
        "كد كالا/خدمت": 'kala_code',
        "كالا/خدمت": 'kala',
        "واحد اصلي": 'vahed',
        "مقدار-اصلي": 'prime-num',
        "في": 'fee',
        "مبلغ فروش": 'sell_price',
        "تخفيف": 'discount',
        "مبلغ بعد از تخفیف": 'sell_after_discount',
        "ماليات": 'tax',
        "عوارض": 'toll',
        "خالص": 'pure',
        "ماه": 'month',
        "ارز": 'currency',
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],

      startDate: '',
      endDate: "",
      endDateDisable: true,



    };
  },

  computed: {
    factorsListData: {
      get() {
        return this.$store.getters["company/getFactors"];
      },
      set(value) {
      },
    },

    excelTitle: {
      get() {
        return `|`
      },
      set(value) {
      },
    },
    fileName: {
      get() {
        return `consultantReport`
        //return `${this.userProfile.firstName} ${this.userProfile.lastName}`
      },
      set(value) {
      },
    },

  },
  watch: {
    // options: {
    //   handler() {
    //     this.readDataFromAPI();
    //   },
    // },
    startDate: {
      handler() {
        if (this.startDate != "") {
          this.endDateDisable = false;
          this.endDate = "";
        } else {
          this.endDateDisable = true;
          this.endDate = "";
        }
      },
    },

  },
  async mounted() {
    await this.$store.dispatch('company/fetchFactors',{number:this.$route.params.id})
  },
  methods: {

    checkType(data) {
      return typeof data.item !== "object";
    },

    async readDataFromAPI() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let data = await this.$store.dispatch("app/fetchAppList", {
        page: page,
        count: itemsPerPage,
        // name: this.searchName,

      });
      this.loading = false;
      ////console.log("data.limit", data.limit);
      this.appData = data.docs;
      this.totalUsers = data.totalDocs;
      this.numberOfPages = data.totalPages;
    },


    setIdConfirm(item, method) {
      this.confirmID = item._id;
      this.confirmRole = item.role;
      this.confirmMethod = method;
      this.dialog = true;
    },

    async confirm() {
      this.dialog = false;
      await this.confirmMethod();
      await this.readDataFromAPI();
    },

    async filter() {
      // this.convertDateToTimestamp(this.startDate),
      await this.$store.dispatch("company/fetchContracts", {
        bill_number :this.search_bill_number,
        start_date:this.convertDateToTimestamp(this.startDate),
        end_date:this.convertDateToTimestamp(this.endDate),
        customer_code:this.search_customer_code,
        customer_name:this.search_customer_name,
        bill_date:this.convertDateToTimestamp(this.search_bill_date),
      });
    },

    async confirmNew() {
      this.dialogNew = false;
      await this.$store.dispatch('app/createApp', {
        appName: this.appName,
        appId: this.appId
      })
      await this.readDataFromAPI();

    },
    pushToStreamPage(item) {
      console.log(item)
      this.$router.push({name: 'StreamList', params: {id: item._id, name: item.appName}})
    },
    resetForm(){

    },
    transformDateToJalali(value) {
      return moment(value).format('jYYYY/jMM/jDD')
    },
    convertDateToTimestamp(date) {
      return new Date(
        moment(date, "jYYYY/jMM/jDD").format("YYYY/MM/DD")
      ).getTime();
    },
    /**
     * In a real application this would be a call to fetch() or axios.get()
     */
  },
};
</script>

<style>
.v-text-field__slot input {
  color: black !important;
}

body {
  text-align: right;
}

td {
  /*color: black !important;*/
}
</style>
